import { useEffect } from 'react';

const THROTTLE_MS = 30000; // Post at most once every 30 seconds

/**
 * When BankRec is running inside the SP6 iframe, user activity inside BankRec
 * is invisible to SP6. This hook detects user activity and posts a message to
 * the SP6 parent window so it can reset its session timeout timer.
 */
export const useSP6KeepAlive = () => {
  useEffect(() => {
    // Only run when embedded inside an iframe (i.e. SP6)
    if (window === window.parent) return;

    let lastPosted = 0;

    const notifyParent = () => {
      const now = Date.now();
      if (now - lastPosted > THROTTLE_MS) {
        lastPosted = now;
        window.parent.postMessage('sp6KeepAlive', '*');
      }
    };

    const events: string[] = ['click', 'keypress', 'mousemove'];
    events.forEach((evt) => document.addEventListener(evt, notifyParent, { passive: true }));

    return () => {
      events.forEach((evt) => document.removeEventListener(evt, notifyParent));
    };
  }, []);
};
